import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../app/hooks/useAuth'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'

interface AuthGuardProps {
  isPrivate: boolean
}

export function AuthGuard({ isPrivate }: AuthGuardProps) {
  const { signedIn } = useAuth()
  const { showCodeScreen } = useWhitelabelContext()

  if (!signedIn && isPrivate) {
    return <Navigate to={showCodeScreen ? '/' : '/signIn'} replace />
  }

  if (signedIn && !isPrivate) {
    return <Navigate to="/transacoes" replace />
  }

  return <Outlet />
}
